import clsx from 'clsx';
import useWindowDimensions from 'hooks/useWindowDimensions';
import Skeleton from 'react-loading-skeleton';
import { BREAK_S } from 'utils/breakpoints';
import { getEnvironment } from 'utils/environmentHelper/environmentHelper';
import mainItemStyles from '../MainList/MainItem/MainItem.module.css';
import mainListStyles from '../MainList/MainList.module.css';
import sideItemStyles from '../SideList/SideItem/SideItem.module.css';
import sideListStyles from '../SideList/SideList.module.css';
import wrapperStyles from '../WhatsNew.module.css';
import styles from './WhatsNewLoader.module.css';

export const WhatsNewLoader = () => {
  const { width } = useWindowDimensions();
  const isMobile = width <= BREAK_S;

  const SideDetails = (
    <>
      <Skeleton
        containerClassName={styles.sideItemText}
        baseColor="var(--color-secondary-80)"
      />
      <Skeleton
        containerClassName={styles.sideItemText}
        baseColor="var(--color-secondary-90)"
      />
      <Skeleton
        containerClassName={styles.sideItemText}
        baseColor="var(--color-secondary-90)"
      />
    </>
  );

  return (
    <div
      data-testid="whats-new-loader"
      className={clsx(wrapperStyles.whatsNew, styles.loader, {
        [wrapperStyles.isStaging]: getEnvironment() === 'staging',
      })}
    >
      <div className={wrapperStyles.view}>
        <div className={wrapperStyles.contentWrapper}>
          <div className={styles.titleWrapper}>
            <h1 className={styles.titleLoader}>
              <Skeleton
                className={styles.skeleton}
                baseColor="var(--color-secondary-80)"
              />
            </h1>
            <p className={styles.subTitle}>
              <Skeleton
                className={styles.skeleton}
                baseColor="var(--color-secondary-90)"
              />
            </p>
          </div>

          <div className={wrapperStyles.content}>
            <div className={sideListStyles.sideListWrapper}>
              <div className={sideListStyles.sideList}>
                {Array.from({ length: 5 }).map((_, index) => (
                  <div
                    key={index}
                    className={clsx(sideItemStyles.sideItem, styles.sideItem)}
                  >
                    <div className={styles.sideItemSkeleton} color="white">
                      {SideDetails}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className={mainListStyles.content}>
              {Array.from({ length: 5 }).map((_, index) => (
                <div
                  key={index}
                  className={clsx(mainItemStyles.mainItem, styles.mainItem)}
                >
                  <div className={styles.sideItemSkeleton}>
                    {isMobile && SideDetails}
                    <Skeleton
                      containerClassName={styles.mainItemImage}
                      height="100%"
                      baseColor="var(--color-secondary-80)"
                    />
                    <Skeleton
                      className={styles.mainItemText}
                      baseColor="var(--color-secondary-90)"
                      count={4}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
